import type { KeyboardKeys } from "../types/HotkeyCommand";
import { getCharacterFromEvent } from "./getCharacterFromEvent";

/** Checks whether a keyboard event exactly matches one of the supplied shortcuts. */
export default function matchesKeyboardShortcut(event: KeyboardEvent, hotkeys: KeyboardKeys | readonly KeyboardKeys[]): boolean {
    const eventHotkey = getCharacterFromEvent(event).char.toLowerCase();
    const shortcuts = Array.isArray(hotkeys) ? hotkeys : [hotkeys];
    
    return shortcuts.some(hotkey => hotkey.toLowerCase() === eventHotkey);
}
